import React from "react";
import CallBackHoursSection from "./CallBackHoursSection";
import CallHoursSection from "./CallHoursSection";
import RegularHoursSection from "./RegularHoursSection";
import TimecardTabs from "./TimecardTabs";
import { getTotal } from "../../utils/timecard";

export default function TimecardEntryArea({
  activeTab,
  onTabChange,
  regularRows,
  callRows,
  callbackRows,
  onRegularRowChange,
  onRegularTookBreakChange,
  onCallRowChange,
  onCallBackRowChange,
  hospitalOptions,
  weekStartDate,
  onClockAction,
  readOnly = false
}) {
  const getCallHospitalForDay = React.useCallback(
    (day) => callRows.find((row) => row.day === day)?.hospital ?? "",
    [callRows]
  );

  const sections = {
    regular: (
      <RegularHoursSection
        rows={regularRows}
        onChange={onRegularRowChange}
        onTookBreakChange={onRegularTookBreakChange}
        hospitalOptions={hospitalOptions}
        weekStartDate={weekStartDate}
        readOnly={readOnly}
      />
    ),
    call: (
      <CallHoursSection
        rows={callRows}
        onChange={onCallRowChange}
        hospitalOptions={hospitalOptions}
        weekStartDate={weekStartDate}
        readOnly={readOnly}
      />
    ),
    callback: (
      <CallBackHoursSection
        rows={callbackRows}
        onChange={onCallBackRowChange}
        getHospitalForDay={getCallHospitalForDay}
        hospitalOptions={hospitalOptions}
        weekStartDate={weekStartDate}
        readOnly={readOnly}
      />
    )
  };

  const totals = {
    regular: getTotal(regularRows),
    call: getTotal(callRows),
    callBack: getTotal(callbackRows)
  };

  return (
    <section className="time-entry-area" aria-label="Timecard entries">
      <TimecardTabs activeTab={activeTab} totals={totals} onChange={onTabChange} />

      <div
        id={`${activeTab}-panel`}
        className="tab-panel"
        role="tabpanel"
        aria-labelledby={`${activeTab}-tab`}
      >
        {sections[activeTab]}
      </div>
    </section>
  );
}
